var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBandage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: "512px",
    viewBox: "0 0 512 512",
    width: "512px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 389.463,
    cy: 165.222,
    rx: 14.973,
    ry: 14.973,
    transform: "matrix(.831 -.556 .556 .831 -26.082 244.605)",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 346.665,
    cy: 123.327,
    rx: 14.973,
    ry: 14.973,
    transform: "matrix(.094 -.996 .996 .094 191.468 456.944)",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 404.426,
    cy: 107.235,
    rx: 14.973,
    ry: 14.973,
    transform: "matrix(1 -.002 .002 1 -.177 .668)",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 165.267,
    cy: 389.418,
    rx: 14.973,
    ry: 14.973,
    transform: "matrix(.991 -.133 .133 .991 -50.212 25.374)",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112.899 335.921c-5.909 5.785-6.01 15.264-.226 21.173s15.264 6.01 21.173.226 6.01-15.264.226-21.173c-5.785-5.91-15.264-6.011-21.173-.226z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 107.28,
    cy: 404.381,
    rx: 14.973,
    ry: 14.973,
    transform: "matrix(.991 -.133 .133 .991 -52.71 17.811)",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m416.634 256.331 76.509-76.509c25.142-25.142 25.142-66.051 0-91.193l-69.772-69.772c-25.141-25.142-66.052-25.142-91.193 0l-76.509 76.509-75.803-75.803c-25.2-25.201-65.99-25.204-91.193 0l-69.771 69.771c-25.201 25.2-25.204 65.99 0 91.193l75.803 75.803-75.097 75.098c-25.142 25.142-25.142 66.051 0 91.193l69.771 69.771c25.139 25.139 66.048 25.147 91.193 0l75.098-75.097 75.803 75.803c25.2 25.201 65.99 25.204 91.193 0l69.771-69.772c25.201-25.2 25.204-65.99 0-91.193zm-63.242-216.261c13.476-13.476 35.289-13.478 48.766 0l69.772 69.772c13.476 13.476 13.478 35.289 0 48.766l-76.509 76.509-118.538-118.538zm-194.033 431.109c-13.476 13.476-35.289 13.478-48.766 0l-69.771-69.771c-13.476-13.476-13.478-35.289 0-48.766l75.097-75.098 118.538 118.538zm311.865-69.066-69.771 69.772c-13.445 13.445-35.321 13.445-48.766 0l-312.572-312.571c-13.445-13.445-13.445-35.321 0-48.766l69.772-69.771c13.444-13.444 35.321-13.445 48.766 0l312.571 312.571c13.444 13.444 13.444 35.32 0 48.765z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m336.858 259.84-84.698-84.698c-5.855-5.855-15.356-5.857-21.214 0l-55.053 55.054c-5.858 5.858-5.858 15.355 0 21.214l84.697 84.697c5.858 5.858 15.355 5.858 21.214 0l55.054-55.053c5.855-5.855 5.857-15.357 0-21.214zm-65.661 44.446-63.483-63.483 33.839-33.84 63.484 63.484z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 346.778,
    cy: 388.712,
    rx: 14.973,
    ry: 14.973,
    transform: "matrix(.88 -.475 .475 .88 -142.962 211.21)",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m399.146 335.215c-5.909-5.784-15.389-5.683-21.173.226s-5.683 15.389.226 21.173 15.389 5.683 21.173-.226c5.785-5.909 5.684-15.389-.226-21.173z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m394.065 393.201c-5.784 5.909-5.683 15.389.226 21.173s15.389 5.683 21.173-.226 5.683-15.389-.226-21.173-15.388-5.683-21.173.226z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 123.288,
    cy: 165.222,
    rx: 14.973,
    ry: 14.973,
    transform: "matrix(.325 -.946 .946 .325 -73.051 228.065)",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 166.086,
    cy: 123.327,
    rx: 14.973,
    ry: 14.973,
    transform: "matrix(.012 -1 1 .012 40.768 287.916)",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m119.024 96.762c-5.784-5.909-15.264-6.01-21.173-.226-5.909 5.785-6.01 15.264-.226 21.173s15.264 6.01 21.173.226c5.91-5.784 6.011-15.264.226-21.173z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBandage);
export default __webpack_public_path__ + "static/media/bandage.9206fb4a5d00124d84c7f489bf21b174.svg";
export { ForwardRef as ReactComponent };